var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H14.2727C13.0672 2 11.911 2.52678 11.0586 3.46447C10.2062 4.40215 9.72727 5.67392 9.72727 7V10H7V14H9.72727V22H13.3636V14H16.0909L17 10H13.3636V7C13.3636 6.73478 13.4594 6.48043 13.6299 6.29289C13.8004 6.10536 14.0316 6 14.2727 6H17V2Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.60d8053a8bb1b9d0139f9da290a5615d.svg";
export { ForwardRef as ReactComponent };